/** When your routing table is too long, you can split it into small modules **/
import Blank from '../../layout/blank'

export default [
  {
    path: '/setting/admin',
    name: 'setting-admin',
    meta: {
      title: '管理员',
      icon: 'fe-users',
      roles: [
        'setting-admins-list-view',
        'setting-admins-roles-view'
      ]
    },
    alwaysShow: true,
    component: Blank,
    children: [
      {
        path: '/setting/admin/list',
        component: () => import('../../view/admin/index'),
        name: 'setting-admin-list',
        meta: { 
          title: '管理员列表', 
          icon: 'fe-user', 
          affix: true,
          roles: ['setting-admins-list-view']
        }
      },
      {
        path: '/setting/admin/role',
        name: 'setting-admin-role',
        component: () => import('../../view/admin-roles/index'),
        meta: {
          title: '角色管理',
          icon: 'fe-list',
          roles: ['setting-admins-roles-view']
        }
      }
    ]
  },
  {
    path: '/setting/common-param',
    component: () => import('../../view/common-param/index'),
    name: 'setting-common-param',
    meta: {
      title: '公共参数',
      icon: 'fe-tag',
      roles: ['setting-common_param-view']
    }
  },
  {
    path: '/setting/system-config',
    component: () => import('../../view/system-config/index'),
    name: 'users-user-groups',
    meta: {
      title: '系统配置',
      icon: 'fe-settings',
      roles: ['setting-config-view']
    }
  },
  // {
  //   path: '/setting/operation-logs',
  //   component: () => import('../../view/setting/operation_logs/index'),
  //   name: 'setting-operation-logs',
  //   meta: {
  //     title: '操作日志',
  //     icon: 'mdi mdi-format-list-checks',
  //     roles: ['setting-operation']
  //   }
  // },
  {
    path: '/setting/login-logs',
    component: () => import('../../view/setting/login_logs/index'),
    name: 'setting-login-logs',
    meta: {
      title: '登录日志',
      icon: 'mdi mdi-format-list-checks',
      roles: ['setting-login-view']
    }
  }
]
